import { useEffect, useRef, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { useSelector } from "react-redux";

// hooks and utilities
import { useRedirectNew, routerOptions } from "hooks/useRedirect";
import { useLanguage } from "lang/Translate";
import useRemember from "hooks/useRemember";
import { useTabNew } from "hooks/useTab";

// components
import AircraftPopup from "./AircraftPopup/AircraftPopup";
import AirportPopup from "./AirportPopup/AirportPopup";

// styles
import "./SideWindow.scoped.scss";

function SideWindow() {
	const tabDetails = useTabNew("", routerOptions.get("s"), true);
	const { id: tab, name: titles } = useRemember(tabDetails);
	const redirect = useRedirectNew(routerOptions.get("s"));
	const history = useSelector(state => state.sideWindow.history);
	const current = useSelector(state => state.sideWindow.currentAddress);
	const lang = useLanguage();
	const scrollRef = useRef();

	const [ref, setRef] = useState(null);
	const [color, setColor] = useState("darkBlue");

	history[history.length - 1] === current && history.pop();

	useEffect(() => {
		if (!ref) {
			setColor("darkBlue");
			return;
		}

		setColor(ref.color);
	}, [ref]);

	useEffect(() => {
		if (!scrollRef.current) return;
		scrollRef.current.scrollToTop();
	}, [tab]);

	return (
		<div className={`side_window ${!tabDetails && "hidden"}`}>
			<>
				<div id="header" className={color}>
					{history.length > 0 && <i className={`fas fa-arrow-left back`} onClick={() => redirect("BACK")} />}
					<p className="flight_number">{titles != null && titles[+(lang !== "PL")]}</p>
					<i className="fas fa-times" onClick={() => redirect("")} />
				</div>
				<Scrollbars
					className="scroll_container"
					hideTracksWhenNotNeeded={true}
					renderTrackVertical={props => <div {...props} className="track_vertical" />}
					renderThumbVertical={props => <div {...props} className="thumb_vertical" />}
					ref={scrollRef}
				>
					{tab === "aircraft" && <AircraftPopup ref={setRef} />}
					{tab === "airport" && <AirportPopup />}
				</Scrollbars>
			</>
		</div>
	);
}

export default SideWindow;
